import { CollectionApp } from '@features/collection'
import { OrganizationApp } from '@features/organizations'
import { AppType } from '@features/app-type'
export function App({
  appType,
  devMode
}: {
  appType: AppType
  devMode: boolean
}) {
  switch (appType) {
    case 'organization':
      return <OrganizationApp devMode={devMode} />
    case 'client':
      return <CollectionApp />
  }
}
